var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAgriNotEnrolledIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9,
  stroke: "#fff",
  strokeWidth: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.8 5v4.538C4.72 9.938 4 11 4 12.188 4 13.75 5.2 15 6.7 15c1.374 0 2.526-1.075 2.682-2.5h2.52c-.066.2-.102.412-.102.625 0 .497.19.974.527 1.326.338.351.796.549 1.273.549s.935-.197 1.273-.55a1.92 1.92 0 0 0 .419-1.95H16v-1.875c0-.694-.534-1.25-1.2-1.25h-2.976L10.99 5zM7 6.25h3l.6 3.125v1.875H9.244a2.83 2.83 0 0 0-.868-1.261A2.66 2.66 0 0 0 7 9.394zm-.3 4.531c.358 0 .701.148.955.412.253.264.395.622.395.995 0 .372-.142.73-.395.994a1.32 1.32 0 0 1-.955.412c-.358 0-.701-.148-.955-.412a1.44 1.44 0 0 1-.395-.995c0-.372.142-.73.395-.994.254-.264.597-.412.955-.412m6.9 1.406c.239 0 .468.1.636.275a.96.96 0 0 1 .264.663.96.96 0 0 1-.264.663.88.88 0 0 1-.636.274.88.88 0 0 1-.636-.274.96.96 0 0 1-.264-.663c0-.249.095-.487.264-.663a.88.88 0 0 1 .636-.274"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 2,
  d: "M16.5 4 4 16.5"
})));
export default SvgAgriNotEnrolledIcon;